export default __webpack_public_path__ + "static/media/logo-dark.c430eb2a.svg";